import { CreateTemplateBlock } from '@/components/chat/components/CreateTemplateBlock';
import type { ToolUseItem } from '@heidi/agents/contracts';

import { friendlyToolError } from '@heidi/agents/data';
import { readString, readToolData, readToolError } from './shared/readers';
import { toCreateTemplateStatus } from './status';

export const renderCreateTemplateToolUse = (item: ToolUseItem): JSX.Element | null => {
  // A queued create can still be the first event of a multi-template approval
  // batch. Let the timeline's quiet Working state own this ambiguous phase;
  // rendering a singular card here causes a visible one-template → batch swap.
  if (item.status === 'queued') return null;
  const status = toCreateTemplateStatus(item.status);
  if (!status) return null;

  const data = readToolData(item);
  const templateId =
    readString(data, 'template_id') ?? readString(item.input, 'template_id');
  // create_template's result names the template field `name` (not template_name).
  const templateName = readString(data, 'name') ?? readString(item.input, 'name');

  // Without anything to identify the template the rich block carries no more
  // information than GenericToolUseRow — fall through cleanly.
  if (!templateId && !templateName) return null;

  if (status === 'error') {
    return (
      <CreateTemplateBlock
        status="error"
        templateId={templateId}
        templateName={templateName}
        error={friendlyToolError(readToolError(item))}
      />
    );
  }

  return (
    <CreateTemplateBlock
      status={status}
      templateId={templateId}
      templateName={templateName}
    />
  );
};
